import React, { FC, useState } from 'react';
import { Grid, Typography, IconButton, Menu, MenuItem } from '@mui/material';
import { MoreHoriz } from '@mui/icons-material';
import { IActionItem, IGridCardActionProps } from './interfaces';

/**
 * @param actionItems The data that defines the actions
 * @param dataItem
 * @param key
 * @param menuOpenListener
 * @param menuCloseListener
 * @constructor
 * @deprecated
 */
const GridCardAction: FC<IGridCardActionProps> = ({
  actionItems,
  dataItem,
  key,
  menuOpenListener,
  menuCloseListener
}) => {
  const [menuAnchorEl, setMenuAnchorEl] = useState<HTMLButtonElement | null>();

  const filterActionItems: () => Array<IActionItem> | undefined = () => {
    return actionItems?.filter((action) => {
      return !action.hideWhen || !action.hideWhen(dataItem, key);
    });
  };

  const filteredActionItems = actionItems?.length ? filterActionItems() : [];
  const hasData = !!filteredActionItems?.length;


  const handleOpen = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
      event.stopPropagation();
      if (event.currentTarget instanceof HTMLButtonElement) {
          setMenuAnchorEl(event.currentTarget);
      }

      menuOpenListener && menuOpenListener(dataItem, key)
  };

  const handleClose = () => {
      setMenuAnchorEl(null);

      menuCloseListener && menuCloseListener(dataItem, key)
  };

  const handleOnClick = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>, actionItem: IActionItem) => {
    event.stopPropagation();
    handleClose();
    actionItem.onClick(dataItem, key);
  }

  return (
    hasData && (
      <Grid xs={12} sm={6} md={2} item >
        <IconButton sx={{
          position: 'absolute',
          top: '38%',
          right: '0.5em',
          color: 'rgba(0, 0, 0, 0.54)'
        }}
          onClick={handleOpen}
        >
          <MoreHoriz />
        </IconButton>

        <Menu
          id="simple-menu"
          anchorEl={menuAnchorEl}
          keepMounted
          open={Boolean(menuAnchorEl)}
          onClose={handleClose}
          sx={{
            '& .MuiPopover-paper': {
              boxShadow: '0px 3px 14px 2px rgba(0, 0, 0, 0.12)',
            }
          }}
        >
          { // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            filteredActionItems?.map((actionItem: IActionItem, index: number) => ( // @ts-expect-error
            <MenuItem key={index} onClick={(event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => { handleOnClick(event, actionItem); }}>
              {actionItem.icon ? actionItem.icon : ''}
              <Typography sx={{ ml: 1 }} variant='body1' color='primary'>
                {actionItem.label}
              </Typography>
            </MenuItem>
          ))}
        </Menu>
      </Grid>
    )
  );
}

export default GridCardAction;